export function fullScreenLoader() {
    // 이미 존재하면 다시 만들지 않음
    if (document.getElementById("full-screen-loader")) {
        return document.getElementById("full-screen-loader")!;
    }

    const loader = document.createElement("div");
    loader.id = "full-screen-loader";
    loader.style.position = "fixed";
    loader.style.top = "0";
    loader.style.left = "0";
    loader.style.width = "100%";
    loader.style.height = "100%";
    // Theme-aware overlay: 85% of the active @paper token so the loader
    // dims the page on both light and dark themes without washing out the
    // rabbit (which uses @ink).
    loader.style.backgroundColor =
        "color-mix(in srgb, var(--bq-paper) 85%, transparent)";
    loader.style.display = "flex";
    loader.style.flexDirection = "column";
    loader.style.justifyContent = "center";
    loader.style.alignItems = "center";
    loader.style.zIndex = "9999";
    loader.style.pointerEvents = "all";

    const rabbit = document.createElement("span");
    rabbit.className = "loader";
    rabbit.style.fontSize = "1.6rem";
    loader.appendChild(rabbit);
    loader.setAttribute("translate", "no");

    if (document.body) {
        return document.body.appendChild(loader);
    } else {
        // body가 없으면 html에 직접 추가
        return document.documentElement.appendChild(loader);
    }
}

export function removeFullScreenLoader() {
    const loaderElement = document.getElementById("full-screen-loader");
    if (loaderElement) {
        document.body.removeChild(loaderElement);
    }
}

// export function showDropDown(e) {
//     let getCustomSelect = document.getElementsByClassName("customSelect");
//     let currentTarget = e.currentTarget;
//     for (let i = 0; i < getCustomSelect.length; i++) {
//         if (currentTarget.isEqualNode(getCustomSelect[i])) {
//             continue;
//         }

//         let getMoreVert = getCustomSelect[i].lastChild;
//         getMoreVert.style.display = "none";
//     }

//     let getMoreVert = currentTarget.lastChild;
//     if (getMoreVert.style.display === "none") {
//         getMoreVert.style.display = "block";
//     } else {
//         getMoreVert.style.display = "none";
//     }
// };

// let hideMoreVert = (e) => {
//     let getMoreVert = document.getElementsByClassName("moreVert");

//     for (let i = 0; i < getMoreVert.length; i++) {
//         if (
//             getMoreVert[i].style.display == "block" &&
//             !getMoreVert[i].contains(e.target)
//         ) {
//             getMoreVert[i].style.display = "none";
//         }
//     }
// };

// document.addEventListener("click", hideMoreVert);
